/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
import ChatStates from './GenesysChatStates';
import CobrowseStates from './GenesysCobrowseStates';
import TextStates from './GenesysTextStates';
import ClientDetails from './ClientDetails';
import FormFields from '../../../../../vendor/genesys_cx/formFields';

const getCobrowseSessionIdMessage = () => {
  const gcbToolbar = document.querySelector('.gcb-toolbar');
  let sessionIdMsg = '';
  if (gcbToolbar) {
    const sessionId = gcbToolbar.getAttribute('data-gcb-session-id');
    if (!Number.isNaN(sessionId)) {
      const formattedSessionId = sessionId.split('').map((letter, index) => (index > 0 && index % 3 === 0 ? `-${letter}` : letter)).join('');
      sessionIdMsg = ` Session ID: ${formattedSessionId}.`;
    }
  }
  return sessionIdMsg;
};

const toastObserver = new MutationObserver(() => {
  const toastContainer = document.querySelector('#_gcb_toast-container');
  if (toastContainer) {
    const updated = toastContainer.getAttribute('data-updated');
    if (updated !== 'true') {
      toastContainer.setAttribute('data-updated', 'true');
      toastContainer.setAttribute('role', 'alert');

      const toast = toastContainer.querySelector('._gcb_toast-message');
      if (toast) {
        const message = toast.textContent;
        if (message === 'Representative has joined the session') {
          const msgNode = document.createTextNode(` You're now sharing your screen. ${getCobrowseSessionIdMessage()}`);
          toast.appendChild(msgNode);
          window.setTimeout(() => {
            // Focus on the cobrowse toolbar
            const toolbar = document.querySelector('.gcb-toolbar');
            toolbar.focus();
          }, 4000);
        }
      }
    }
  }
});

const modalTextObserver = new MutationObserver(mutations => {
  if (mutations[0]?.target.style.display === 'block') {
    const btn = mutations[0]?.target.querySelector('.cx-callback button.cx-failed-retry');
    btn.focus();
  }
});

const openChatWindow = (formData, autoSubmit) => {
  window._genesysHandler.command('WebChat.open', {
    // Do not change keys genesys specific
    userData: {
      ...formData,
      sessionId: '',
      SourceURL: window.location.href,
      // service: (window.__ENV || {}).REACT_APP_GENESYS_CHAT_SERVICE || 'ER_Chat_ApplyNow',
      BrowserVersion: ClientDetails.usersBrowserVersion,
      Browser: ClientDetails.usersBrowserName,
      OperatingSystem: ClientDetails.usersOperatingSystem,
      IPAddress: ClientDetails.usersPotentialIpAddress,
      IdentifyCreateContact: 0,
      fullStoryURL: ClientDetails.getFullStoryUrl(),
      FullStoryURL: ClientDetails.getFullStoryUrl(),
    },
    form: {
      autoSubmit,
      [FormFields.firstName]: formData.FirstName,
      [FormFields.lastName]: formData.LastName,
      [FormFields.emailAddress]: formData.EmailAddress,
    },
  });
};

const closeChatWindow = () => {
  window._genesysHandler.command('WebChat.close');
};

const formatPhoneTo10Digits = phoneNumber => {
  // Format the phone number to 10 digits
  // required for texting.
  try {
    const formatted = phoneNumber.substr(-10);
    if (/[0-9]{10}/.test(formatted)) {
      return formatted;
    }
    return '';
  } catch (err) {
    return '';
  }
};

const openTextWindow = (formData, autoSubmit) => {
  window._genesysHandler.command('Callback.open', {
    // Do not change keys genesys specific
    userData: {
      ...formData,
      sessionId: '',
      SourceURL: window.location.href,
      // service: (window.__ENV || {}).REACT_APP_GENESYS_CHAT_SERVICE || 'ER_Chat_ApplyNow',
      BrowserVersion: ClientDetails.usersBrowserVersion,
      Browser: ClientDetails.usersBrowserName,
      OperatingSystem: ClientDetails.usersOperatingSystem,
      IPAddress: ClientDetails.usersPotentialIpAddress,
      IdentifyCreateContact: 0,
      fullStoryURL: ClientDetails.getFullStoryUrl(),
      FullStoryURL: ClientDetails.getFullStoryUrl(),
    },
    form: {
      autoSubmit,
      [FormFields.firstName]: formData.FirstName,
      [FormFields.lastName]: formData.LastName,
      [FormFields.phoneNumber]: formatPhoneTo10Digits(formData.PhoneNumber),
      [FormFields.subject]: formData.Subject,
    },
  });
};

const closeTextWindow = () => {
  window._genesysHandler.command('Callback.close');
};

// Cannot use WebChat.showChatButton if chatButton.enabled = false
const enableChatButton = () => {
  window._genesysHandler.command('WebChat.showChatButton');
};

const disableChatButton = () => {
  window._genesysHandler.command('WebChat.hideChatButton');
};

const inviteToChat = () => {
  window._genesysHandler.command('WebChat.invite');
};

const clickElement = element => {
  const e = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  element.dispatchEvent(e);
};

const focusCloseButton = () => {
  const closeButton = document.querySelector('.cx-widget .cx-close-confirm.cx-btn');
  if (closeButton) {
    closeButton.focus();
  }
};

const focusSupportMenuCloseButton = () => {
  const closeButton = document.querySelector('aside.supportTools #supportMenuButton');
  if (closeButton) {
    closeButton.focus();
  }
};

const emojiClickOnEnterHandler = event => {
  if (event.code === 'Enter' || event.code === 'Space') {
    event.preventDefault();
    const emojiButtonSvg = document.querySelector('.cx-webchat .cx-emoji svg');
    const element = event.target;
    clickElement(element);
    clickElement(emojiButtonSvg); // Hide the emoji menu
  }
};

const applyADAEmoji = async () => {
  const webChat = document.querySelector('.cx-webchat');
  let emojiMenu = webChat.querySelector('.cx-emoji-menu');

  let attempt = 0;
  while (!emojiMenu && attempt < 8) {
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => setTimeout(resolve, 250));
    emojiMenu = webChat.querySelector('.cx-emoji-menu');
    attempt++;
  }
  if (emojiMenu) {
    const emojiSmile = emojiMenu.querySelector('.cx-smile');
    const emojiThumbsup = emojiMenu.querySelector('.cx-thumbsup');
    const emojiSad = emojiMenu.querySelector('.cx-sad');

    emojiMenu.setAttribute('aria-label', 'List of 3 emoji');
    emojiMenu.setAttribute('tabindex', '0');
    emojiSmile.setAttribute('aria-label', 'Smiley face, 1 of 3');
    emojiSmile.setAttribute('tabindex', '0');
    emojiThumbsup.setAttribute('aria-label', 'Thumbs up, 2 of 3');
    emojiThumbsup.setAttribute('tabindex', '0');
    emojiSad.setAttribute('aria-label', 'Sad face, 3 of 3');
    emojiSad.setAttribute('tabindex', '0');

    emojiMenu.querySelectorAll('.cx-option').forEach(element => {
      element.removeEventListener('keydown', emojiClickOnEnterHandler);
      element.addEventListener('keydown', emojiClickOnEnterHandler);
    });
  }
};

const applyADAWebChat = () => {
  const webChat = document.querySelector('.cx-webchat');

  const webChatTitle = webChat.querySelector('.cx-titlebar .cx-title');
  const webChatIcon = webChat.querySelector('.cx-titlebar .cx-icon');
  const webChatInput = webChat.querySelector('.cx-message-input');

  const transcript = webChat.querySelector('.cx-transcript');
  const emojiButton = webChat.querySelector('.cx-emoji');
  const cobrowseButton = webChat.querySelector('.cx-cobrowse');
  const charCount = webChat.querySelector('.cx-char-count');
  const genesysLogo = webChat.querySelector('.cx-branding-icon');

  emojiButton.addEventListener('click', () => {
    applyADAEmoji();
  });
  emojiButton.addEventListener('keydown', event => {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      const svg = emojiButton.querySelector('svg');
      clickElement(svg);
    }
  });
  cobrowseButton.addEventListener('keydown', event => {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      const svg = cobrowseButton.querySelector('svg');
      clickElement(svg);
    }
  });

  transcript.setAttribute('aria-atomic', 'false');

  webChatIcon.setAttribute('aria-hidden', 'true');
  webChatTitle.setAttribute('aria-label', 'Live Chat');
  webChatInput.setAttribute('aria-label', 'Type your chat message and press enter to submit');
  cobrowseButton.setAttribute('aria-label', 'Start Co-browse screen sharing');
  emojiButton.setAttribute('aria-label', 'Send Emoji');
  charCount.setAttribute('aria-label', 'Characters left to type before you have to press enter and send the message');
  genesysLogo.setAttribute('aria-hidden', 'true');

  webChat.setAttribute('tabindex', '0');
};

const applyADACobrowse = () => {
  // Wrapped in try/catch since these elements are created
  // by a plugin outside of this codebase
  try {
    const toolbar = document.querySelector('.gcb-toolbar');
    const handle = toolbar.querySelector('.gcb-drag-handle');
    const exitButton = toolbar.querySelector('.gcb-toolbar-exit');

    toolbar.setAttribute('aria-label', `Co-browse session toolbar. ${getCobrowseSessionIdMessage()}`);
    toolbar.setAttribute('tabindex', '0');
    handle.setAttribute('aria-label', 'Co-browse toolbar handle');
    exitButton.setAttribute('aria-label', 'Exit Co-browse');
    exitButton.setAttribute('tabindex', '0');

    exitButton.addEventListener('keydown', event => {
      if (event.code === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        const svg = exitButton.querySelector('svg');
        clickElement(svg);

        window.setTimeout(() => {
          // Focus back on the chat:
          const webChatInput = document.querySelector('.cx-webchat .cx-message-input');
          webChatInput.focus();
        }, 4000);
      }
    });

    const gcbAppStatus = document.querySelector('.gcb-appStatus');

    if (gcbAppStatus) {
      const updated = gcbAppStatus.getAttribute('data-updated');
      if (updated !== 'true') {
        const closeButton = gcbAppStatus.querySelector('.gcb-appStatus-close');
        gcbAppStatus.setAttribute('data-updated', 'true');
        gcbAppStatus.setAttribute('role', 'status');
        gcbAppStatus.setAttribute('tabindex', 0);

        const msgNode = document.createTextNode(`You're now sharing your screen with an agent.${getCobrowseSessionIdMessage()}`);
        closeButton.parentNode.insertBefore(msgNode, closeButton);
        gcbAppStatus.focus();
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};

const waitForGenesysToLoad = async () => {
  while (!window._genesysHandler) {
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => setTimeout(resolve, 250));
  }
};

const subscribeToChatState = (dispatcher, handler) => {
  // Run IIFE in async state until window._genesysHandler is available
  (async () => {
    await waitForGenesysToLoad();
    window._genesysHandler.subscribe('WebChat.opened', () => {
      applyADAWebChat();
      dispatcher(handler(ChatStates.OPENED));
    });
    window._genesysHandler.subscribe('WebChat.closed', () => {
      dispatcher(handler(ChatStates.CLOSED));
      focusSupportMenuCloseButton();
    });
    window._genesysHandler.subscribe('WebChat.cancelled', () => {
      dispatcher(handler(ChatStates.CANCELLED));
      focusCloseButton();
    });
    window._genesysHandler.subscribe('WebChat.completed', () => {
      dispatcher(handler(ChatStates.COMPLETED));
      focusSupportMenuCloseButton();
    });
  })();
};

const subscribeToCobrowseState = (dispatcher, handler) => {
  (async () => {
    await waitForGenesysToLoad();
    window._genesysHandler.subscribe('CoBrowse.ready', () => { dispatcher(handler(CobrowseStates.READY)); });
    window._genesysHandler.subscribe('CoBrowse.online', () => { dispatcher(handler(CobrowseStates.ONLINE)); });
    window._genesysHandler.subscribe('CoBrowse.started', () => {
      toastObserver.observe(document.body, { childList: true });
      applyADACobrowse();
      dispatcher(handler(CobrowseStates.STARTED));
    });
    window._genesysHandler.subscribe('CoBrowse.stopped', () => {
      toastObserver.disconnect();
      dispatcher(handler(CobrowseStates.STOPPED));
    });
  })();
};

const unsubscribeToChatState = () => {
  (async () => {
    await waitForGenesysToLoad();
    window._genesysHandler.unsubscribe('WebChat.opened');
    window._genesysHandler.unsubscribe('WebChat.closed');
    window._genesysHandler.unsubscribe('WebChat.cancelled');
    window._genesysHandler.unsubscribe('WebChat.completed');
  })();
};

const unsubscribeToCobrowseState = () => {
  (async () => {
    await waitForGenesysToLoad();
    window._genesysHandler.unsubscribe('CoBrowse.ready');
    window._genesysHandler.unsubscribe('CoBrowse.online');
    window._genesysHandler.unsubscribe('CoBrowse.started');
    window._genesysHandler.unsubscribe('CoBrowse.stopped');
  })();
};

const subscribeToTextState = (dispatcher, handler) => {
  // Run IIFE in async state until window._genesysHandler is available
  (async () => {
    await waitForGenesysToLoad();
    window._genesysHandler.subscribe('Callback.opened', () => {
      // applyADAWebChat();
      dispatcher(handler(TextStates.OPENED));
      modalTextObserver.observe(document.querySelector('.cx-callback .cx-dialog.cx-close-confirm'), { attributes: true, attributeFilter: ['style'] });
      modalTextObserver.observe(document.querySelector('.cx-callback .cx-dialog.cx-error-container'), { attributes: true, attributeFilter: ['style'] });
      document.querySelector('.cx-callback form.cx-content').removeAttribute('tabindex');
    });
    window._genesysHandler.subscribe('Callback.closed', () => { dispatcher(handler(TextStates.CLOSED)); });
    window._genesysHandler.subscribe('Callback.cancelled', () => {
      dispatcher(handler(TextStates.CANCELLED));
      modalTextObserver.disconnect();
      focusSupportMenuCloseButton();
    });
    window._genesysHandler.subscribe('Callback.completed', () => {
      dispatcher(handler(TextStates.COMPLETED));
      focusSupportMenuCloseButton();
    });
  })();
};

const unsubscribeToTextState = () => {
  (async () => {
    await waitForGenesysToLoad();
    window._genesysHandler.unsubscribe('Callback.opened');
    window._genesysHandler.unsubscribe('Callback.closed');
    window._genesysHandler.unsubscribe('Callback.cancelled');
    window._genesysHandler.unsubscribe('Callback.completed');
  })();
};

export default {
  openChatWindow,
  closeChatWindow,
  enableChatButton,
  disableChatButton,
  inviteToChat,
  subscribeToChatState,
  subscribeToCobrowseState,
  unsubscribeToChatState,
  unsubscribeToCobrowseState,
  openTextWindow,
  closeTextWindow,
  subscribeToTextState,
  unsubscribeToTextState,
};
